<template>
    <div v-bind:style="{ height: height + 'px' }">
        <MglMap
            :accessToken="mapToken"
            :mapStyle.sync="mapStyle"
            :pitch="pitch"
            :zoom="zoom"
            @load="onMapLoaded"
            :center="[centerLon, centerLat]"
        >
            <MglMarker v-if="markers" v-for="marker in markers" :coordinates="[marker.lon,marker.lat]">
                <template slot="marker">
                    <div class="cursor-as-pointer">
                        <div v-if="!marker.thumb" class="title text-uppercase"
                             style="text-align:center;position: absolute; top: 40%; left: 50%; transform: translate(-50%, -200%); width:200px;" :style="getCustomMarkerStyle(marker)">
                            {{ marker.name }}
                        </div>
                        <v-icon v-if="!marker.thumb" large @click="openMarkerLink(marker)" :style="getCustomMarkerStyle(marker)">fa-map-marker-alt
                        </v-icon>
                        <v-tooltip top v-if="marker.thumb">
                            <template v-slot:activator="{ on }">
                                <div class="title text-uppercase"
                                     style="text-align:center;position: absolute; top: 40%; left: 50%; transform: translate(-50%, -200%); width:200px;" :style="getCustomMarkerStyle(marker)">
                                    {{ marker.name }}
                                </div>
                                <v-icon large v-on="on" @click="openMarkerLink(marker)" :style="getCustomMarkerStyle(marker)">fa-map-marker-alt</v-icon>
                            </template>
                            <div style="width:300px;" @click="openMarkerLink(marker)">
                                <v-img :src="marker.thumb"></v-img>
                                <h2 class="mt-2 mb-2">{{ marker.name }}</h2>
                            </div>
                        </v-tooltip>
                    </div>
                </template>
            </MglMarker>
        </MglMap>
    </div>
</template>

<script>
import {callAPI} from '@/helper'
import Mapbox from "mapbox-gl";
import {MglMap, MglMarker} from "vue-mapbox";
import moment from "moment";
import data3Processor from "../mixins/data3Processor";

export default {
    props: {
        height: {type: Number, default: 500},
        mapToken: {
            type: String,
            default: "pk.eyJ1IjoiYWxleGRvYnJlIiwiYSI6ImNrN3BtZHZxcTAyMGwzcmwyaDA1cnR0ODMifQ.qUYFNvUiAyO9XaM_vRajWw"
        },
        mapStyle: {type: String, default: "mapbox://styles/alexdobre/ck7zqwh9i2e681intld6eat26"},
        pitch: {type: Number, default: 30},
        zoom: {type: Number, default: 16},
        centerLon: {type: Number, default: 114.1584},
        centerLat: {type: Number, default: 22.282225},
        markers: {type: Array, default: null},
        colors: {type: Array, default: null},
        data3query: {type: Object, default: null},
        dateRange: {type: Object, default: null},
    },
    components: {
        MglMap, MglMarker
    },
    mixins: [data3Processor],
    computed: {},
    name: 'MapWidget',
    watch: {
        dateRange() {
            if (this.dateRange && this.data3query) {
                this.refresh()
            }
        },
    },
    data: function () {
        return {
            mapActions: null,
            timeout: null,
            points: null,
        }
    },
    mounted(){
        if (this.dateRange && this.data3query) {
            this.refresh()
        }
    },
    methods: {
        getCustomMarkerStyle(marker){
            if (marker.colorSeries&&marker.colorSeries!==""&&this.points&&this.points[marker.colorSeries]!==undefined&&this.colors){
                let value=this.points[marker.colorSeries]
                for (let color of this.colors){
                    if (value>=color.min&&value<=color.max){
                        return "color:"+color.value
                    }
                }
            }
            return ""
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.doRefresh, 500);
        },
        async doRefresh() {
            if (this.data3query) {
                let payloadArray = JSON.parse(JSON.stringify(this.data3query['data-payload']))
                payloadArray = payloadArray.filter(x => x.filters && (x.filters.sensor_name || x.filters.equipment_name))
                for (let payload of payloadArray) {
                    this.processDateRange(payload,this.dateRange)
                    if (!payload.filters.facility_name && this.$store.state.pointsListStore.pointsList.facility_name) {
                        payload.filters.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
                    }
                    if (payload.onOnly) {
                        if (!payload.pipeline) {
                            payload.pipeline = []
                        }
                        payload.pipeline.unshift(
                            {
                                "type": "filter",
                                "filter_op": "eq",
                                "filter_by": "* - on",
                                "filter_value": 1,
                            }
                        )
                    }
                }
                let results = await Promise.all(payloadArray.map(p => callAPI('data3/', p)))
                let newPoints = {}
                for (let result of results) {
                    for (let seriesIndex in result.data) {
                        if (seriesIndex === "timestamp") {
                            continue
                        }
                        newPoints[seriesIndex]=result.data[seriesIndex].reduce((acc, curr) => curr !== null ? curr : acc)
                    }
                }
                this.points = newPoints
            }
        },
        onMapLoaded(event) {
            this.mapActions = event.component.actions;
        },
        openMarkerLink(marker) {
            if (marker.link) {
                let pass = localStorage.getItem('pass');
                let url = marker.link + "?token=" + pass;
                if (process.env.VUE_APP_SINGLE_WINDOW_MODE) {
                    window.location.href = url
                } else {
                    window.open(url, '_blank')
                }
            }

        },

    },
    created() {
        this.mapbox = Mapbox;
    },
}

</script>

<style scoped>

</style>
